var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "products"
  }, [_c('v-row', {
    staticClass: "ma-0"
  }, [_c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.campaigns && _vm.campaigns.length > 1,
      expression: "campaigns && campaigns.length > 1"
    }],
    staticClass: "campaign-list flex-grow-0 flex-shrink-0"
  }, [_c('div', {
    staticClass: "page-title flex-shrink-0 mono pl-10 pb-4"
  }, [_vm._v(_vm._s(_vm.$t('campaigns')))]), _vm._l(_vm.campaigns, function (campaign) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.loadingCampaigns,
        expression: "!loadingCampaigns"
      }],
      key: campaign.id,
      staticClass: "sidebar-item pl-10 pr-2 py-2",
      class: {
        'selected': _vm.selectedCampaign.id == campaign.id
      },
      on: {
        "click": function ($event) {
          return _vm.selectCampaign(campaign);
        }
      }
    }, [_vm._v(" " + _vm._s(campaign.name) + " ")]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loadingCampaigns,
      expression: "loadingCampaigns"
    }],
    staticClass: "campaign-skeleton-ctn"
  }, [_c('v-skeleton-loader', {
    attrs: {
      "width": "100%",
      "type": "list-item"
    }
  })], 1)], 2), _c('v-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.campaigns && _vm.campaigns.length === 1 && _vm.isAvailable('qrmanager:elabel'),
      expression: "campaigns && campaigns.length === 1 && isAvailable('qrmanager:elabel')"
    }],
    staticClass: "campaign-list flex-grow-0 flex-shrink-0"
  }, [_c('div', {
    staticClass: "page-title flex-shrink-0 mono pl-10 pb-4"
  }, [_vm._v(" " + _vm._s(_vm.$t('brands')) + " ")]), _c('v-row', {
    staticClass: "ma-2",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.openBrandDialog
    }
  }, [_c('v-icon', {
    staticClass: "mr-3"
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t('brand_create')) + " ")], 1)], 1), _c('v-form', {
    staticClass: "brand-search px-1 pb-4",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.filterBrands.apply(null, arguments);
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('search_brands'),
      "loading": _vm.searchingBrands,
      "append-icon": "mdi-magnify",
      "clearable": "",
      "dense": "",
      "hide-details": "",
      "solo": ""
    },
    on: {
      "click:append": _vm.filterBrands
    },
    model: {
      value: _vm.brandSearchText,
      callback: function ($$v) {
        _vm.brandSearchText = $$v;
      },
      expression: "brandSearchText"
    }
  })], 1), _vm._l(_vm.brands, function (brand) {
    return _c('v-row', {
      key: brand.id,
      staticClass: "sidebar-item position-relative pl-10 ma-0 pr-2 py-2",
      class: {
        'selected': _vm.selectedBrand && _vm.selectedBrand.id === brand.id
      },
      attrs: {
        "align": "center"
      },
      on: {
        "mouseover": function ($event) {
          _vm.overBrand = brand.id;
        },
        "mouseleave": function ($event) {
          _vm.overBrand = 0;
        },
        "click": function ($event) {
          return _vm.selectBrand(brand);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(brand.name))]), _vm.overBrand === brand.id ? _c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref) {
          var on = _ref.on,
            attrs = _ref.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "edit-brand-btn ml-auto pa-0 my-0 mr-2",
            attrs: {
              "small": "",
              "color": "primary",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.editBrand(brand);
              }
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-pencil")])], 1)];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('brand_update')))])]) : _vm._e()], 1);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loadingBrands && !_vm.searchingBrands,
      expression: "loadingBrands && !searchingBrands"
    }],
    staticClass: "campaign-skeleton-ctn"
  }, [_c('v-skeleton-loader', {
    attrs: {
      "width": "100%",
      "type": "list-item"
    }
  })], 1), !_vm.loadingBrands && !_vm.brands.length && _vm.brandSearchText ? _c('div', {
    staticClass: "brand-search-empty px-4 pb-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('brands_not_found')) + " ")]) : _vm._e()], 2), _c('v-col', {
    staticClass: "product-list flex-grow-1",
    class: {
      'pl-2': _vm.campaigns.length == 1
    }
  }, [_c('div', {
    staticClass: "product-actions-ctn d-flex mb-2 pt-2 align-center flex-wrap flex-grow-1"
  }, [!_vm.isAvailable('qrmanager:product:csv') ? _c('v-btn', {
    staticClass: "md-raised primary mr-4",
    on: {
      "click": _vm.openCreateProductModal
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-plus")]), _vm._v(_vm._s(_vm.$t('new_product')) + " ")], 1) : _vm._e(), _vm.isAvailable('qrmanager:product:csv') ? _c('v-btn', {
    staticClass: "md-raised primary mr-4",
    on: {
      "click": function ($event) {
        _vm.manageProductDialog = true;
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "black"
    }
  }, [_vm._v("mdi-plus")]), _vm._v(_vm._s(_vm.$t('new_product')) + " ")], 1) : _vm._e(), _vm.isAvailable('qrmanager:codes:list') && _vm.products.length ? _c('router-link', {
    attrs: {
      "to": "/codes"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.goToManageAll();
      }
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-qrcode")]), _vm._v(_vm._s(_vm.$t('all_qr_codes')))], 1)], 1) : _vm._e(), _vm.isAvailable('qrmanager:elabel_bulk_upload') ? _c('router-link', {
    attrs: {
      "to": "/bulk-upload"
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-cloud-upload")]), _vm._v(_vm._s(_vm.$t('upload_elabel_data')))], 1)], 1) : _vm._e(), _vm.selectedCampaign.id && _vm.canExportElabelData ? _c('router-link', {
    attrs: {
      "to": {
        name: 'elabel-export'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "color": "primary",
      "data-test": "elabel-export-action"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-database-export-outline")]), _vm._v(_vm._s(_vm.$t('elabel_export_title')) + " ")], 1)], 1) : _vm._e(), _c('v-spacer'), _c('codes-quota', {
    staticClass: "mr-3"
  })], 1), _c('v-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.totalProductsCount,
      expression: "totalProductsCount"
    }],
    staticClass: "pt-2 pb-2",
    on: {
      "submit": _vm.filterProducts
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('search_products'),
      "solo": "",
      "hide-details": "",
      "append-icon": "mdi-magnify"
    },
    on: {
      "click:append": _vm.filterProducts
    },
    model: {
      value: _vm.productSearch,
      callback: function ($$v) {
        _vm.productSearch = $$v;
      },
      expression: "productSearch"
    }
  })], 1), _c('div', {
    staticClass: "d-flex align-center total-ctn"
  }, [this.campaigns.length > 1 && _vm.totalProductsCount > 0 ? _c('div', {
    staticClass: "d-flex brands-filter"
  }, [_c('v-icon', {
    staticClass: "flex-shrink-0 mt-2 mr-2"
  }, [_vm._v("$filter")]), _c('v-autocomplete', {
    staticClass: "mt-2",
    attrs: {
      "items": _vm.brandsList,
      "item-text": "name",
      "return-object": "",
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.selectBrand
    },
    model: {
      value: _vm.brandInput,
      callback: function ($$v) {
        _vm.brandInput = $$v;
      },
      expression: "brandInput"
    }
  })], 1) : _vm._e(), _c('v-spacer', {
    staticClass: "mr-2"
  }), !_vm.loadingProducts && _vm.products.length ? _c('div', {
    staticClass: "search-label pt-2 mono"
  }, [_vm._v(_vm._s(_vm.$t('products')) + ": " + _vm._s(_vm.filteredProductCount))]) : _vm._e()], 1), !_vm.loadingProducts && _vm.totalProductsCount > 0 && _vm.products.length === 0 ? _c('div', {
    staticClass: "d-flex justify-center mt-8"
  }, [_vm._v(" " + _vm._s(_vm.$t('products_not_found')) + " ")]) : _vm._e(), _vm._l(_vm.products, function (product) {
    var _product$elabel, _product$elabel2, _product$elabel3, _product$elabel4;
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.loadingProducts,
        expression: "!loadingProducts"
      }],
      key: product.id,
      staticClass: "product-card mb-2"
    }, [_c('v-row', {
      staticClass: "ma-0"
    }, [_c('div', {
      staticClass: "product-picture flex-grow-0 pa-0",
      style: {
        'background-image': 'url(' + _vm.getProductImage(product) + ')'
      }
    }), _c('div', {
      staticClass: "product-info-ctn flex-grow-1 pa-0 pl-3"
    }, [_c('div', {
      staticClass: "product-title-ctn d-flex align-center mt-2"
    }, [_c('span', {
      staticClass: "product-title font-weight-medium pr-3"
    }, [_vm._v(_vm._s(product.name))]), product.elabel && product !== null && product !== void 0 && (_product$elabel = product.elabel) !== null && _product$elabel !== void 0 && _product$elabel.is_published && _vm.getELabelStatus(product) !== 'inactive' || !(product !== null && product !== void 0 && (_product$elabel2 = product.elabel) !== null && _product$elabel2 !== void 0 && _product$elabel2.is_published) && _vm.getELabelStatus(product) !== 'inactive' && _vm.getELabelStatus(product) !== null ? _c('div', {
      staticClass: "align-self-start"
    }, [_c('v-menu', {
      attrs: {
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref2) {
          var on = _ref2.on,
            attrs = _ref2.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            attrs: {
              "color": "primary",
              "icon": ""
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)];
        }
      }], null, true)
    }, [_c('v-list', [_c('v-list-item', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.editProduct(product);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('edit_product')))])], 1), _vm.isAvailable('qrmanager:elabel') ? _c('v-list-item', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.duplicateProduct(product);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('duplicate_product')))])], 1) : _vm._e(), product.elabel && product !== null && product !== void 0 && (_product$elabel3 = product.elabel) !== null && _product$elabel3 !== void 0 && _product$elabel3.is_published && _vm.getELabelStatus(product) !== 'inactive' ? _c('v-list-item', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.unpublishElabel(product);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('disable_elabel')))])], 1) : _vm._e(), product.elabel && !(product !== null && product !== void 0 && (_product$elabel4 = product.elabel) !== null && _product$elabel4 !== void 0 && _product$elabel4.is_published) && _vm.getELabelStatus(product) !== 'inactive' ? _c('v-list-item', {
      staticClass: "pointer",
      on: {
        "click": function ($event) {
          return _vm.publishElabel(product);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('enable_elabel')))])], 1) : _vm._e()], 1)], 1)], 1) : _c('v-tooltip', {
      attrs: {
        "top": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function (_ref3) {
          var on = _ref3.on,
            attrs = _ref3.attrs;
          return [_c('v-btn', _vm._g(_vm._b({
            staticClass: "ma-1 ml-3",
            attrs: {
              "x-small": "",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.editProduct(product);
              }
            }
          }, 'v-btn', attrs, false), on), [_c('v-icon', {
            attrs: {
              "color": "#15bbf0"
            }
          }, [_vm._v("mdi-pencil")])], 1)];
        }
      }], null, true)
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('edit_product')))])])], 1), _c('div', {
      staticClass: "product-description"
    }, [_vm._v(_vm._s(_vm.$t('product_sku')) + ": " + _vm._s(product.sku))]), product.brand ? _c('div', {
      staticClass: "product-description"
    }, [_vm._v(_vm._s(_vm.$t('brand')) + ": [" + _vm._s(product.brand.reference) + "] " + _vm._s(product.brand.name))]) : _vm._e(), _vm.isAvailable('qrmanager:elabel') ? _c('div', {
      staticClass: "d-flex elabel-status align-center"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('elabel_status')) + ":")]), _c('span', {
      staticClass: "status-pill mx-2",
      class: `${_vm.getELabelStatus(product)}`
    }), _vm.getELabelStatus(product) === 'published' ? _c('span', [_vm._v(_vm._s(_vm.$t('published')))]) : _vm.getELabelStatus(product) === 'draft' ? _c('span', [_vm._v(_vm._s(_vm.$t('draft')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('not_created')))])]) : _vm._e()]), _c('div', {
      staticClass: "d-flex align-center ml-auto"
    }, [_vm.isAvailable('qrmanager:elabel') ? _c('v-btn', {
      staticClass: "mr-3",
      attrs: {
        "raised": ""
      },
      on: {
        "click": function ($event) {
          return _vm.goToElabel(product);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('edit_elabel_data')))]) : _vm._e(), _c('div', {
      staticClass: "get-code-ctn pa-2",
      on: {
        "click": function ($event) {
          return _vm.manageCodes(product);
        }
      }
    }, [_c('div', {
      staticClass: "d-flex justify-center pt-4"
    }, [_c('v-icon', {
      staticClass: "mr-2",
      attrs: {
        "color": "black"
      }
    }, [_vm._v("mdi-qrcode")]), _c('div', {
      staticClass: "code-count font-weight-light"
    }, [_vm._v("x " + _vm._s(product.code_count ? product.code_count : 0))])], 1), _c('v-btn', {
      staticClass: "mt-1",
      attrs: {
        "color": "primary",
        "small": "",
        "text": ""
      }
    }, [_vm._v(_vm._s(_vm.$t('get_qr_codes')))])], 1)], 1)])], 1);
  }), _vm.loadingProducts ? _c('div', {
    staticClass: "skeleton-ctn"
  }, [_c('v-skeleton-loader', {
    attrs: {
      "width": "100%",
      "type": "avatar, paragraph"
    }
  })], 1) : _vm._e(), !_vm.loadingProducts && _vm.totalProductsCount === 0 ? _c('div', {
    staticClass: "empty-state-ctn"
  }, [_c('img', {
    staticClass: "guide-arrow",
    attrs: {
      "src": require("@/assets/guide_arrow.svg")
    }
  }), _c('img', {
    staticClass: "product-cta",
    attrs: {
      "src": require("@/assets/product-cta.jpeg")
    }
  }), _c('div', {
    staticClass: "py-4 font-weight-medium"
  }, [_vm._v(" " + _vm._s(_vm.$t('product_empty_state_1'))), _c('br'), _vm._v(" " + _vm._s(_vm.$t('product_empty_state_2')) + " ")])]) : _vm._e(), _c('div', {
    staticClass: "pagination-ctn mt-5 mb-4"
  }, [_c('v-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.loadingProducts && _vm.filteredProductCount > 0,
      expression: "!loadingProducts && filteredProductCount > 0"
    }],
    attrs: {
      "color": "primary",
      "total-visible": 7,
      "length": _vm.nbPages
    },
    model: {
      value: _vm.page,
      callback: function ($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 2)], 1), _vm.brandDialog ? _c('v-dialog', {
    attrs: {
      "width": "600",
      "persistent": true
    },
    model: {
      value: _vm.brandDialog,
      callback: function ($$v) {
        _vm.brandDialog = $$v;
      },
      expression: "brandDialog"
    }
  }, [!this.brandToEdit ? _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('brand_create_title')))]) : _vm._e(), this.brandToEdit ? _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('brand_update')))]) : _vm._e(), _c('brand-form', {
    attrs: {
      "brand": this.brandToEdit ? this.brandToEdit : {},
      "brand-id": this.brandToEdit && this.brandToEdit.id ? this.brandToEdit.id : null,
      "brand-products-count": _vm.totalProductsCount,
      "brand-products-loading": _vm.loadingProducts
    },
    on: {
      "on-brand-created": _vm.handleBrandCreated,
      "on-brand-deleted": _vm.handleBrandDeleted,
      "on-close-dialog": function ($event) {
        _vm.brandDialog = false;
      }
    }
  })], 1) : _vm._e(), _c('v-dialog', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.productDialog,
      expression: "productDialog"
    }],
    attrs: {
      "width": "900",
      "persistent": true
    },
    model: {
      value: _vm.productDialog,
      callback: function ($$v) {
        _vm.productDialog = $$v;
      },
      expression: "productDialog"
    }
  }, [this.$route.name === 'products.duplicate' ? _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('duplicate_product')))]) : this.$route.params.id ? _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('edit_product')))]) : _c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('create_product')))]), _c('product-form', {
    key: _vm.productDialog,
    attrs: {
      "campaign": this.selectedCampaign.id,
      "product": this.$route.params && this.$route.params.product ? this.$route.params.product : {},
      "product-id": this.$route.params && this.$route.params.id ? this.$route.params.id : null
    },
    on: {
      "on-product-created": _vm.onProductCreated,
      "switch-to-product-brand": _vm.switchToProductBrand,
      "on-close-dialog": _vm.handleCloseProductDialog
    }
  })], 1), _c('v-dialog', {
    attrs: {
      "width": "600"
    },
    model: {
      value: _vm.manageProductDialog,
      callback: function ($$v) {
        _vm.manageProductDialog = $$v;
      },
      expression: "manageProductDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('product_create_update')))]), _c('div', {
    staticClass: "pt-4"
  }, [_c('v-row', {
    staticClass: "ma-0 pa-0",
    attrs: {
      "align": "center",
      "justitfy": "center"
    }
  }, [_c('v-col', {
    staticClass: "text-center"
  }, [_c('v-btn', {
    attrs: {
      "fab": ""
    },
    on: {
      "click": _vm.openCreateProductModal
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "primary"
    }
  }, [_vm._v(" mdi-plus ")])], 1), _c('div', {
    staticClass: "pt-4"
  }, [_vm._v(_vm._s(_vm.$t('new_product')))])], 1), _c('v-col', {
    staticClass: "text-center"
  }, [_c('product-csv', {
    on: {
      "open-dialog": function ($event) {
        _vm.manageProductDialog = false;
      },
      "upload-complete": _vm.loadProducts
    }
  })], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function ($event) {
        _vm.manageProductDialog = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }